import {
  CommentOutlined,
  HubOutlined,
  KeyboardTabOutlined,
} from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";
import { grey } from "@mui/material/colors";
import { isArray, size } from "lodash";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import EnhancedCommentItemRenderer from "../../../../_src_shared/comments/EnhancedCommentItemRenderer";
import { DetailSection } from "../../../../_src_shared/common/DetailSection/DetailSection";
import AssociationsSelector from "../../../../components/associations/AssociationsSelector";
import useAssociationUtils from "../../../../components/associations/hooks/useAssociationUtils";
import Flx from "../../../../components/layout/Flx";
import Txt from "../../../../components/typography/Txt";
import { useCommentUtilsHook } from "../../../../hooks/utils/useCommentUtilsHook";

const BorrowerAssociationPane = ({
  show,
  onClose,
  alt = false,
  borrower,
  sx,
}) => {
  if (!show) {
    return null;
  }

  if (alt) {
    return (
      <Flx column gap={3}>
        <BorrowerAssociationsSection borrower={borrower} />
        <BorrowerCommentsSection borrower={borrower} />
      </Flx>
    );
  }
  return (
    <Flx
      // gap={2}
      gap={0.5}
      column
      sx={{
        flexGrow: 0,
        flexShrink: 1,
        flexBasis: "480px",
        p: 3,
        borderRadius: 4,
        // background: "#eeeeee70", // grey[200],
        // background: "#ffffff", // grey[200],
        // border: "2px solid #e0e0e09e",
        // border: "1px solid #e0e0e09e",
        alignSelf: "flex-start",
        ...sx,
      }}
    >
      {/* <Flx fw jb ac>
        <Txt
          bold
        >{`${borrower?.firstName} ${borrower?.lastName} Related Items`}</Txt>

        {onClose && (
          <Tooltip title="Collapse Related Items Pane">
            <IconButton size="small" onClick={() => onClose(false)}>
              <KeyboardTabOutlined className="thin" />
            </IconButton>
          </Tooltip>
        )}
      </Flx> */}
      <Flx column gap={3}>
        <BorrowerAssociationsSection borrower={borrower} />
        <BorrowerCommentsSection borrower={borrower} />
      </Flx>
    </Flx>
  );
};

const BorrowerAssociationsSection = ({ borrower }) => {
  const { getTotalArrayItems } = useAssociationUtils();
  return (
    <>
      <DetailSection
        title={`Borrower Associations (${getTotalArrayItems(borrower?.associations)})`}
        variant="card"
        collapsible={true}
        defaultExpanded={false}
        // fontSize={12}
        // fontWeight={600}
        icon={<HubOutlined className="thin" fontSize="small" />}
      >
        <AssociationsSelector
          associationTypeName="borrowers"
          associationTypeId={borrower?._id}
          associations={borrower.associations}
        />
      </DetailSection>
    </>
  );
};

const BorrowerCommentsSection = ({ borrower }) => {
  const loanDrilldown = useSelector((state) => state.loanDrilldown);
  const { getCommentsAssociatedWithBorrower } = useCommentUtilsHook();

  const associatedComments = useMemo(() => {
    const targetId = borrower?._id;
    return getCommentsAssociatedWithBorrower(loanDrilldown?.comments, targetId);
  }, [getCommentsAssociatedWithBorrower, loanDrilldown?.comments, borrower]);
  return (
    <>
      <DetailSection
        title={`Borrower Comments (${size(associatedComments)})`}
        variant="card"
        // fontSize={12}
        // fontWeight={600}
        collapsible={true}
        defaultExpanded={false}
        contentSx={{ p: 0 }}
        icon={<CommentOutlined className="thin" fontSize="small" />}
      >
        <BorrowerCommentsRenderer comments={associatedComments} />
      </DetailSection>
    </>
  );
};

const BorrowerCommentsRenderer = ({ comments, borrowerId }) => {
  const loanDrilldown = useSelector((state) => state.loanDrilldown);
  const { getCommentsAssociatedWithBorrower } = useCommentUtilsHook();

  const associatedComments = useMemo(() => {
    if (isArray(comments)) {
      return comments;
    }
    const targetId = borrowerId;
    return getCommentsAssociatedWithBorrower(loanDrilldown?.comments, targetId);
  }, [
    comments,
    getCommentsAssociatedWithBorrower,
    loanDrilldown?.comments,
    borrowerId,
  ]);
  return (
    <>
      <EnhancedCommentItemRenderer
        loan={loanDrilldown}
        comments={associatedComments}
      />
    </>
  );
};
export default BorrowerAssociationPane;
